<template>
    <div class="esepom">
        <div class="container">
            <div class="breadcrumb">
                <router-link to="/">首页</router-link>
                <span>&nbsp;&gt;&nbsp;</span>
                <span>价值赋能</span>
                <span>&nbsp;&gt;&nbsp;</span>
                <router-link to="/value/esg">ESG</router-link>
                <span>&nbsp;&gt;&nbsp;</span>
                <span>节能环保办公方式</span>
            </div>
            <div class="content">
                <div class="title">
                    <div class="index">01</div>
                    <div class="text">办公为什么要低碳？</div>
                </div>
                <div class="list1">
                    <div class="item" v-for="(item, index) in list1" :key="index">
                        <img :src="item.icon" alt="" class="icon">
                        <p v-html="textToHtml(item.text)"></p>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="title">
                    <div class="index">02</div>
                    <div class="text">什么是低碳办公？</div>
                </div>
                <p class="content_desc">在办公等相关场景，从源头设计、办公运营和工作方式等方面，通过建立意识和承诺支持减少排放的行动(包括负责任采购、碳排放管理和技术应用等各方面)，促进节能减排和可持续发展。 </p>
                <EsepomSwiper/>
                <div class="table_wrap">
                    <div class="left">
                        <div class="text">低碳办公&碳减排</div>
                        <div class="desc">温室气体核算体系具体定义了范围一、二、三所涵盖的企业 活动，打造绿色建筑、低碳办公空间、倡导员工绿色方式等 低碳办公举措可以帮助企业减少各范围的碳排放，助力企业 实现碳中和。</div>
                        <div class="table">
                            <ul class="row thead">
                                <li class="item" v-for="(item, index) in table" :key="index">{{item.title}}</li>
                            </ul>
                            <ul class="row">
                                <li class="item" v-for="(item, index) in table" :key="index" v-html="textToHtml(table[index].list[0])"></li>
                            </ul>
                            <ul class="row">
                                <li class="item" v-for="(item, index) in table" :key="index" v-html="textToHtml(table[index].list[1])"></li>
                            </ul>
                            <ul class="row">
                                <li class="item" v-for="(item, index) in table" :key="index" v-html="textToHtml(table[index].list[2])"></li>
                            </ul>
                        </div>
                        <div class="table_mobile">
                            <div class="tabs">
                                <div class="tabs_inner" :style="`width: ${100 * table.length}%; transform: translate(${-(100 / table.length) * tableActiveIndex}%, 0)`">
                                    <div class="item" v-for="(item, index) in table" :key="index">{{item.title}}</div>
                                </div>
                                <div class="btn_prev" v-if="tableActiveIndex > 0" @click="tablePrev"></div>
                                <div class="btn_next" v-if="tableActiveIndex < table.length - 1" @click="tableNext"></div>
                            </div>
                            <div class="list">
                                <div class="item" v-for="(item, index) in table[tableActiveIndex].list" :key="index" v-html="textToHtml(item)"></div>
                            </div>
                        </div>
                    </div>
                    <img class="cover" src="@/assets/images/images_esg_3.jpg" alt=""/>
                </div>
            </div>
            <div class="content">
                <div class="title">
                    <div class="index">03</div>
                    <div class="text">如何实践低碳办公</div>
                </div>
                <div class="esg_4">
                    <img class="cover" src="@/assets/images/images_esg_4.jpg" alt=""/>
                    <div class="list">
                        <div class="title">低碳办公 4R原则</div>
                        <div class="item" 
                        v-for="(item, index) in list3" :key="index"
                        :class="{active: list3ActiveIndex == index}">
                            <div class="text" @click="list3ActiveIndex = index">
                                <img :src="item.icon" alt="" class="icon">
                                <p>{{item.text}}</p>
                            </div>
                            <div class="desc">{{item.desc}}</div>
                        </div>
                    </div>
                </div>
                <div class="list4">
                    <template v-for="(item, index) in list4">
                        <div class="item" :key="index">
                            <div class="text">{{`${index + 1}.${item.text}`}}</div>
                            <div class="desc">
                                <p v-for="(_item, _index) in item.desc" :key="_index">{{_item}}</p>
                            </div>
                        </div>
                        <div class="line" :key="'line_' + index"></div>
                    </template>
                </div>
            </div>
            <div class="content">
                <div class="title pc">
                    <div class="index">04</div>
                    <div class="text">瑞安办公——低碳办公解决方案 & 实践案例</div>
                </div>
                <div class="title mobile">
                    <div class="index">04</div>
                    <div class="text">瑞安办公—</div>
                </div>
                <div class="title mobile">
                    <div class="text">—低碳办公解决方案 & 实践案例</div>
                </div>
                <div class="esg_6">
                    <div class="list">
                        <div class="item" 
                        v-for="(item, index) in list5" :key="index"
                        :class="{active: list5ActiveIndex == index}">
                            <div class="text" @click="list5ActiveIndex = index">
                                <img :src="item.icon" alt="" class="icon pc">
                                <img :src="item.web_icon" alt="" class="icon mobile">
                                <p>{{item.text}}</p>
                            </div>
                            <div class="desc">{{item.desc}}</div>
                        </div>
                    </div>
                    <img class="cover" src="@/assets/images/images_esg_6.jpg" alt=""/>
                </div>
                <p class="p1">企业低碳办公实践 & 低碳影响力</p>
                <p class="p2">瑞安房地产是第⼀家完成了集合第三⽅碳排放核查（⾃2011年起⾄2020年瑞安房地产所有⾃持物业单位平⽅⽶每年碳排放⽐2011年数据下降41%）；可持续认证（主要项⽬均实现LEED、中国绿⾊建筑认证，⽬前LEED认证超过248万⽅）；健康认证（新天地社区成为全球⾸个WELL认证社区，另外瑞安新天地在建资产均将实现WELL，LEED双认证）；SBTi承诺（2021年3⽉瑞安作出承诺成为中国⼤陆第⼀家参加SBTi的房地产企业）唯⼀四项都拥有的房地产企业</p>
                <div class="esg_7">
                    <img src="@/assets/images/images_esg_8.jpg" alt="" class="cover">
                    <p><b>绿⾊电源计划：</b>武汉企业天地1号率先引⼊“绿⾊电源”计划，将通过100%可再⽣清洁能源的使⽤，帮助⼊驻企业实现约223千克/平⽅⽶的年度碳减排⽬标，有效减少每年超4000万千克的碳排放ᰁ，同时，有助于降低项⽬运营过程中电⼒消耗的成本。此外，还将帮助⼊驻企业更好地履⾏绿⾊发展的企业社会责任，进⼀步树⽴绿⾊企业的品牌形象，提升产品和服务竞争⼒。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EsepomSwiper from '../../components/esepomSwiper.vue';
import lineBreaks from '../../utils/lineBreaks';
export default {
    name: "esepom",
    data() {
        return {
            list1: [
                {
                    text: '不可忽视的全球变暖\r和生态问题',
                    icon: require('@/assets/images/icon_esg_1_1.png')
                },
                {
                    text: '需要全力以赴的\r碳中和目标',
                    icon: require('@/assets/images/icon_esg_1_2.png')
                },
                {
                    text: '客观的成本效益',
                    icon: require('@/assets/images/icon_esg_1_3.png')
                },
                {
                    text: '关注员工健康和\r长期可持续发展',
                    icon: require('@/assets/images/icon_esg_1_4.png')
                },
            ],
            tableActiveIndex: 0,
            table: [
                {
                    title: '范围 1 GHG 排放',
                    list: [ 
                        '范围 1 企业拥有或运营控制资产的直接温室气体排放。', 
                        '1.生产电力、热力或蒸汽\r2.物理或化学工艺\r3.运输原料、产品、废弃物和员工\r4.无组织排放', 
                        '示例:\r• 自有建筑中的现场天然气燃烧\r• 发电机和燃料油产生的其他直接燃料用量\r• 自有建筑的制冷剂泄漏\r• 企业私人⻜机出行\r• 企业班⻋的燃油用量'
                    ]
                },
                {
                    title: '范围 2 GHG 排放',
                    list: [ 
                        '范围 2 企业消耗已购买或获取的电力、蒸汽、加热或冷却而产生的间接排放。', 
                        '1.电力传输和配送的间接排放\r2.其他与电力有关的间接排放', 
                        '示例:\r• 办公室和数据中心的用电情况\r• 租赁设施的天然气使用情况\r• 租赁设施的发电机燃料使用情况\r• 租赁设施的蒸汽使用情况\r• 租赁设施的制冷剂泄漏'
                    ]
                },
                {
                    title: '范围 3 GHG 排放',
                    list: [ 
                        '范围 3 在企业价值链中出现的所有间接排放(范围 2 未包含)，其中包括上游和下游排放。范围 3 排放共有 15 个类别', 
                        '1. 外购原料与燃料的开采和生产\r2.相关的运输活动\r3.范围二之外与电力有关的活动\r4.租赁资产、特许和外包活动\r5.使用售出的产品和服务\r6.废弃物处理', 
                        '示例:\r• 购买的商品和服务\r• 资本商品\r• 燃油和能源相关活动\r• 商务旅行\r• 员工通勤(不含企业班⻋) \r• 使用已出售产品\r• 投资'
                    ]
                },
            ],
            list3ActiveIndex: 0,
            list3: [
                {
                    icon: require('@/assets/images/icon_esg_5_1.png'),
                    text: 'Reduce/源头减量化',
                    desc: '从源头着⼿控制所需资源，节约资源，减少不必要的浪费和污染物、废弃物的排放，⽤适量的资源进⾏办公，提⾼利⽤率，减少碳排放。'
                },
                {
                    icon: require('@/assets/images/icon_esg_5_2.png'),
                    text: 'Reuse/循环再使⽤',
                    desc: '减少办公场景下⼀次性制品的使⽤，尽可能᯿复使⽤产品/资源，发挥资源最⼤价值；尽可能多次使⽤；同时尽可能延⻓物品的使⽤期限，减少过度频繁的更新迭代。'
                },
                {
                    icon: require('@/assets/images/icon_esg_5_3.png'),
                    text: 'Recycle/回收再利⽤',
                    desc: '资源在完成其使⽤功能后能进⾏回收和再利⽤。将仍具有利⽤价值的资源或废弃物通过回收再造继续投⼊⽣产和使⽤。'
                },
                {
                    icon: require('@/assets/images/icon_esg_5_4.png'),
                    text: 'Restore/环境友好',
                    desc: '尽可能地避免使⽤不可再⽣资源，选择环境友好的解决⽅案，以促进⾃然系统再⽣；同时，关注员⼯的身体和情绪的健康，设计出舒适和健康的⼯作场所。'
                },
            ],
            list4: [
                {
                    text: '出行',
                    desc: [ '低碳通勤', '低碳差旅' ]
                },
                {
                    text: '餐饮',
                    desc: [ '减少外卖，⿎励带饭或堂⻝', '减少⻝物浪费，⿎励光盘⾏动', '倡导植物性饮⻝', '避免⼀次性餐具使⽤', '厨余垃圾正确分类' ]
                },
                {
                    text: '⽇常办公',
                    desc: [ '减少能耗，如随⼿关闭电脑等办公设备', '节约资源，如节约⽤⽔，减少物料消耗', '减少⼀次性制品使⽤', '资源再利⽤，如⽤品共享、⼆⼿交换和捐赠', '正确垃圾分类和回收' ]
                },
            ],
            list5ActiveIndex: 0,
            list5: [
                {
                    icon: require('@/assets/images/icon_esg_7_1.png'),
                    web_icon: require('@/assets/images/icon_esg_7_11.png'),
                    text: '光能源管理',
                    desc: '新项⽬均会铺设光伏板，以“⾃发⾃⽤，余ᰁ上⽹”原则消纳，可抵消部分电⼒需求，响应双碳政策。 采⽤⾃然采光，利⽤外部⾃然环境，建筑设计在兼顾办公租区进深及效率的同时，给建筑⽤户提供了丰富的视ᰀ体验。 '
                },
                {
                    icon: require('@/assets/images/icon_esg_7_2.png'),
                    web_icon: require('@/assets/images/icon_esg_7_12.png'),
                    text: '建筑',
                    desc: '瑞安办公的新项⽬采⽤不低于总造价20%可循环成分的材料 、区域材料，使⽤耐腐蚀、抗⽼化、耐久性能好的管材、管线、管件，体现循环经济理念。'
                },
                {
                    icon: require('@/assets/images/icon_esg_7_3.png'),
                    web_icon: require('@/assets/images/icon_esg_7_13.png'),
                    text: '⽔资源管理',
                    desc: '采⽤节⽔灌溉系统，并设置⼟壤湿度感应器；⾬⽔回⽤系统，将回收⾬⽔处理后⽤作景观浇灌、⻋库冲洗、地⾯冲洗等；采⽤⾼效的⼀级低流ᰁ节⽔洁具。'
                },
                {
                    icon: require('@/assets/images/icon_esg_7_4.png'),
                    web_icon: require('@/assets/images/icon_esg_7_14.png'),
                    text: '空⽓管理',
                    desc: '瑞安办公的新项⽬设置空⽓质ᰁ监测系统（如PM10, PM2.5，CO2浓度），可实时了解室内空⽓质ᰁ；地下⻋库设有⼀氧化碳监控并联动⻛机启闭，保证⻋库的空⽓品质；瑞安办公的新项⽬办公标准层设可开启窗，保证过渡季典型⼯况下，主要功能房间实现⾃然通⻛换⽓次数不⼩于2次/h，增⼤办公新⻛指标，提⾼了建筑⽤户的舒适度。'
                },
                {
                    icon: require('@/assets/images/icon_esg_7_5.png'),
                    web_icon: require('@/assets/images/icon_esg_7_15.png'),
                    text: '定制化设计解决⽅案',
                    desc: '为客户提供的办公场所咨询服务，提供最匹配其办公模式的办公场所解决⽅案，以助⼒其实现卓越⽣产⼒及新价值创造。循环材料：瑞安办公提供定制化装修；可循环经济-装配式隔断可复⽤精装技术，装配⽅便且可᯿复使⽤，可实现布局灵活变动；效率提⾼50%。'
                },
                {
                    icon: require('@/assets/images/icon_esg_7_6.png'),
                    web_icon: require('@/assets/images/icon_esg_7_16.png'),
                    text: '灵动空间产品服务',
                    desc: '瑞安办公通过WORKX NOW、WORKX SOCIAL、WORKX LAB模块以及与其他商务空间品牌的空间组合，打造未来多功能应⽤与多场景结合的混合办公模式，提质增效，减少路途中和各个场景的碳排放。'
                },
            ],
        };
    },
    computed: {
        textToHtml: lineBreaks.textToHtml,
    },
    components: {
        EsepomSwiper
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        tablePrev(){
            if(this.tableActiveIndex <= 0){
                return false;
            }
            this.tableActiveIndex--;
        },
        tableNext(){
            if(this.tableActiveIndex >= this.table.length - 1){
                return false;
            }
            this.tableActiveIndex++;
        },
    },
};
</script>

<style scoped lang="scss">
.esepom{
    line-height: 1.6;
    @media only screen and (max-width: 1200px) {
        padding: 1rem 0;
    }
}
.breadcrumb{
    padding: .35rem 0 .7rem;
    @media only screen and (max-width: 1200px) {
        display: none;
    }
    :last-child{
        font-weight: bold;
    }
}
.content{
    margin-bottom: .8rem;
    .title{
        font-size: .26rem;
        display: flex;
        align-items: center;
        line-height: .43rem;
        margin-bottom: .5rem;
        &.mobile{
            display: none;
        }
        .index{
            width: .37rem;
            height: .43rem;
            margin-right: .2rem;
            font-family: 'shuionworkx';
            font-size: .24rem;
            color: #fff;
            background: url('~@/assets/images/icon_esg_index.png') no-repeat 0/100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .text{
            flex: 1;
        }
    }
    @media only screen and (max-width: 1200px) {
        margin-bottom: 1rem;
        &:last-child{
            margin-bottom: 0;
        }
        .title{
            justify-content: center;
            font-size: .72rem;
            margin-bottom: 1rem;
            &.pc{
                display: none;
            }
            &.mobile{
                display: flex;
                &~.mobile{
                    margin-top: -.5rem;
                }
            }
            .index{
                width: .7rem;
                height: .81rem;
                margin-right: .3rem;
                font-size: .48rem;
            }
            .text{
                flex: none;
            }
        }
        .content_desc{
            padding: 0 1rem;
            margin-bottom: 1rem;
        }
    }
}
.list1{
    display: flex;
    .item{
        flex: 1;
        text-align: center;
        font-size: .2rem;
        .icon{
            width: 1.67rem;
            margin: 0 auto .5rem;
        }
    }
    @media only screen and (max-width: 1200px) {
        flex-wrap: wrap;
        padding: 0 1rem;
        .item{
            flex: none;
            width: 50%;
            font-size: .36rem;
            margin-top: 1.3rem;
            &:nth-of-type(1),
            &:nth-of-type(2){
                margin-top: 0;
            }
            .icon{
                width: 2.24rem;
            }
        }
    }
}
.table_wrap{
    display: flex;
    align-items: center;
    .left{
        flex: 1;
    }
    .text{
        font-size: .2rem;
        font-weight: bold;
        text-align: center;
        margin-bottom: .1rem;
    }
    .cover{
        width: 5.7rem;
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        .text{
            margin: .8rem 0 .5rem;
            padding: 0 1rem;
        }
        .desc{
            padding: 0 1rem;
        }
        .cover{
            width: 100%;
        }
    }
}
.table{
    font-size: .14rem;
    line-height: 1.4;
    @media only screen and (max-width: 1200px) {
        display: none;
    }
    .row{
        display: flex;
        &:nth-of-type(2n){
            background: #15764a;
            color: #fff;
        }
        &.thead{
            font-weight: bold;
            text-align: center;
            .item{
                border-right: none;
            }
        }
        .item{
            flex: 1;
            padding: .2rem;
            border-right: 1px solid rgba($color: #4db586, $alpha: .3);
            &:last-child{
                border-right: none;
            }
        }
    }
}
.table_mobile{
    display: none;
    @media only screen and (max-width: 1200px) {
        display: block;
        margin: 1rem 0;
        .tabs{
            font-size: .48rem;
            position: relative;
            overflow: hidden;
            margin-bottom: .4rem;
            .tabs_inner{
                display: flex;
                justify-content: center;
                align-items: center;
                transition: transform .5s;
            }
            .item{
                flex: 1;
                height: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                &.active{
                    font-weight: bold;
                }
            }
            .btn_prev,
            .btn_next{
                position: absolute;
                width: .48rem;
                height: .61rem;
                top: 50%;
                transform: translate(0, -50%);
                background: no-repeat center/100%;
            }
            .btn_prev{
                left: 2.8rem;
                background-image: url('~@/assets/images/icon_arrow_prev3.svg');
            }
            .btn_next{
                right: 2.8rem;
                background-image: url('~@/assets/images/icon_arrow_next3.svg');
            }
        }
        .list{
            .item{
                padding: .8rem 1rem;
                &:nth-of-type(2n - 1){
                    color: #fff;
                    background: #15764a;
                }
            }
        }
    }
}
.esg_4{
    display: flex;
    align-items: flex-start;
    margin-bottom: .5rem;
    .cover{
        width: 6rem;
        margin-right: .5rem;
    }
    .list{
        line-height: 1.2;
        .title{
            font-size: .2rem;
            font-weight: bold;
            margin-bottom: .3rem;
        }
        .item{
            margin-bottom: .3rem;
            &.active{
                .text{
                    &::after{
                        transform: rotate(90deg);
                    }
                }
                .desc{
                    display: block;
                }
            }
            .text{
                font-size: .2rem;
                display: flex;
                align-items: center;
                margin-bottom: .2rem;
                cursor: pointer;
                .icon{
                    width: .29rem;
                    margin-right: .15rem;
                }
                &::after{
                    content: "";
                    display: block;
                    width: .09rem;
                    height: .11rem;
                    background: url('~@/assets/images/icon_arrow_next3.svg') no-repeat 0/100%;
                    margin-left: .1rem;
                }
            }
            .desc{
                padding-left: .45rem;
                display: none;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        margin-bottom: 1rem;
        .cover{
            width: 100%;
            margin: 0;
        }
        .list{
            .title{
                font-size: .6rem;
                padding: .8rem 0;
            }
            .item{
                margin-bottom: 0;
                .text{
                    background: #e6e6e6;
                    height: 1.6rem;
                    border: 1px solid #d8d8d8;
                    padding: 0 2rem 0 1rem;
                    font-size: .48rem;
                    margin-bottom: 0;
                    p{
                        flex: 1;
                    }
                    .icon{
                        width: .8rem;
                        margin-right: .6rem;
                    }
                    &::after{
                        width: .53rem;
                        height: .65rem;
                    }
                }
                .desc{
                    padding: .5rem 1rem;
                }
            }
        }
    }
}
.list4{
    display: flex;
    justify-content: center;
    .item{
        padding: .1rem 0;
        .text{
            font-weight: bold;
        }
        .desc{
            p{
                &::before{
                    content: '- ';
                }
            }
        }
    }
    .line{
        border-right: 1px dashed #8abaa4;
        margin: 0 1rem;
        &:last-child{
            display: none;
        }
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        padding: 0 1rem;
        .item{
            margin-bottom: .8rem;
            .text{
                margin-bottom: .5rem;
            }
        }
        .line{
            display: none;
        }
    }
}
.esg_6{
    display: flex;
    align-items: flex-start;
    margin-bottom: .8rem;
    .cover{
        width: 6rem;
        margin-left: .5rem;
    }
    .list{
        .item{
            margin-bottom: .2rem;
            &.active{
                .text{
                    &::after{
                        transform: rotate(90deg);
                    }
                }
                .desc{
                    display: block;
                }
            }
            .text{
                display: flex;
                font-weight: bold;
                align-items: center;
                margin-bottom: .1rem;
                cursor: pointer;
                .icon{
                    width: .16rem;
                    margin-right: .05rem;
                    &.mobile{
                        display: none;
                    }
                }
                &::after{
                    content: "";
                    display: block;
                    width: .09rem;
                    height: .11rem;
                    background: url('~@/assets/images/icon_arrow_next3.svg') no-repeat 0/100%;
                    margin-left: .1rem;
                }
            }
            .desc{
                display: none;
                padding-left: .02rem;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        flex-direction: column-reverse;
        .cover{
            width: 100%;
            margin: 0;
        }
        .list{
            .title{
                font-size: .6rem;
                padding: .8rem 0;
            }
            .item{
                margin-bottom: 0;
                .text{
                    background: #e6e6e6;
                    height: 1.6rem;
                    border: 1px solid #d8d8d8;
                    padding: 0 2rem 0 1rem;
                    font-size: .48rem;
                    margin-bottom: 0;
                    p{
                        flex: 1;
                    }
                    .icon{
                        width: .9rem;
                        margin-right: .2rem;
                        &.pc{
                            display: none;
                        }
                        &.mobile{
                            display: block;
                        }
                    }
                    &::after{
                        width: .53rem;
                        height: .65rem;
                    }
                }
                .desc{
                    padding: .5rem 1rem;
                }
            }
        }
    }
}
.p1{
    font-weight: bold;
    font-size: .2rem;
    margin-bottom: .1rem;
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem;
        text-align: center;
        font-size: .6rem;
        margin-bottom: .4rem;
    }
}
.p2{
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem;
        margin-bottom: 1rem;
    }
}
.esg_7{
    display: flex;
    align-items: center;
    margin-top: .5rem;
    .cover{
        width: 6rem;
        margin-right: .5rem;
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        margin: 0;
        .cover{
            width: 100%;
            margin: 0;
            margin-bottom: 1rem;
        }
        p{
            padding: 0 1rem;
        }
    }
}
</style>